import { Alert, Box, Paper, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { AddButton, CloseButton, EditButton, GridContainer, Message, ModalContent, ModalHeader, ModalOverlay, PageContainer, TealSwitch, Title } from "../Styles/AppStyles";
import { COLORS } from "../Styles/Colors";
import useGetData from "../Hooks/useGetData";
import { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { PencilIcon } from "lucide-react";
import {EmailForm} from "./Email/EmailForm";
import { Role } from "../Types";
import apiClient from "../Services/ApiClient";
import { useSnackbar } from "../Context/SnackbarProvider";
import { decode } from "../Services/DecodeToken";
import { Header } from "../Components/Header/Header";
import { ColumnDef, DataTable } from "../Components/Table/DataTable";




type EmailCategory = {
    id: number;
    name: string;
    unique_name: string;
    description: string;
    active_flag: number; 
  };
  
  const EmailPage: React.FC = () => {
    const [emailsData, loadingEmail, errorEmail, refetch] = useGetData<EmailCategory>(`/api/emails/subscriptions`);
    const [emailToEdit, setEmailToEdit] = useState<EmailCategory | null>(null);
    const [showModal, setShowModal] = useState(false);
    const [emails, setEmails] = useState<EmailCategory[]>([]);

    const {showSnackbar} = useSnackbar();

      const token: any = decode();
    
      const roleLevel = token.roles.level;

  
    useEffect(() => {
      if (emailsData) {
        setEmails(emailsData.flat());
      }
    }, [emailsData]);
  
    const handleToggle = async(newEmail: EmailCategory) => {
      const toggledEmail = {
        ...newEmail,
        active_flag: newEmail.active_flag ? 0 : 1
      };

      console.log('Toggling email:', toggledEmail);

      const response = await apiClient(`/api/emails/subscriptions/${newEmail.id}/admin`, {
        method: 'PUT',
        body: JSON.stringify(toggledEmail)
      });

      if (!response.ok) {
        const errorData = await response.json();
        showSnackbar(errorData.error, "error");
        return;
      }

      showSnackbar(`${newEmail.name} active is set to ${Boolean(toggledEmail.active_flag)}`, "success", "Successfully Edited!");
      setEmailToEdit(null);

      setEmails(prev =>
        prev.map(email =>
          email.id === newEmail.id
            ? { ...email, active_flag: toggledEmail.active_flag }
            : email
        )
      );
    };


  const handleCloseModal = () => {
    setShowModal(false);
    setEmailToEdit(null);
  }


  const handleSubmit = async(data: any) => {
    


    if(emailToEdit) {
    const response = await apiClient(`/api/emails/subscriptions/${emailToEdit.id}/admin`, {
      method: 'PUT',
      body: JSON.stringify(data)
      });

        if (!response.ok) {
        const errorData = await response.json();
         showSnackbar(errorData.error, "error");
      }


      showSnackbar(`${data.name} is successfully edited`, "success", "Successfully Edited");

      setEmailToEdit(null);
      refetch();
      setShowModal(false);
    } else {
      const response = await apiClient('/api/emails/subscriptions', {
      method: 'POST',
      body: JSON.stringify(data)
      });

        if (!response.ok) {
        const errorData = await response.json();
        showSnackbar(errorData.error, "error");


      }


      showSnackbar(`${data.name} is successfully added`, "success", "Success")

  

      setEmailToEdit(null);
       refetch();
      setShowModal(false);
    }

   

  }


  const [roles, loadingRoles, errorRoles, refetchRoles] = useGetData<Role>('/api/roles');
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' } | null>(null);




  const columns: ColumnDef<any>[] = [];

  if (roleLevel === 100) {
    columns.push({
      field: 'actions',
      headerName: '',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div style={{ display: 'flex', gap: 5, alignItems: 'center', justifyContent: "center", marginTop: 12 }}>
          <EditButton onClick={() => {
            setEmailToEdit(params.row);
            setShowModal(true);
          }}>
            <PencilIcon />
          </EditButton>
        </div>
      )
    });
  }

columns.push(
  { field: 'name', headerName: 'Name', width: 400, sortable: true },
  { field: 'unique_name', headerName: 'Unique Name', width: 200 },
  { field: 'description', headerName: 'Description', width: 600, sortable: true },
  {
    field: 'active_flag',
    headerName: 'Active',
    width: 100,
    renderCell: (params) => (
      <TealSwitch
        checked={!!params.row.active_flag}
        onChange={() => handleToggle(params.row)}
        color="primary"
      />
    )
  }
);

    
  
    return (
      <PageContainer>

      <Header title="Email Subscription" data={emails}>
           {roleLevel === 100 && (
                   <AddButton onClick={() => setShowModal(true)}>+</AddButton>
        )} 

      </Header>
 




     
         

          {showModal && (
                <ModalOverlay>
                  <ModalContent onClick={e => e.stopPropagation()}>
                    <CloseButton onClick={handleCloseModal}>×</CloseButton>
                    <ModalHeader>{emailToEdit ? "Edit" : "Add"} Email Subscription</ModalHeader>
                    <EmailForm onSubmit={handleSubmit} defaultValues={emailToEdit ?? undefined} onCancel={handleCloseModal} availableRoles={roles} />
                  </ModalContent>
                </ModalOverlay>
              )}
  

        <DataTable
          data={emails}
          columns={columns}
          title="Email Subscriptions"
          pageKey="email-management"
          subtitle="Manage your email subscriptions here."
          loading={loadingEmail}
          onRowClick={(row) => {
            setEmailToEdit(row);
          }}
          initialPageSize={10}
          pageSizeOptions={[5, 10, 20]}
        />

     

      </PageContainer>
    );
  };
  
  export default EmailPage;